import classNames from 'classnames';
type FlowBuilderTitleProps = {
    id?: string;
    name: string;
};

const FlowBuilderTitle = ({ id, name }: FlowBuilderTitleProps) => {
    const classes = classNames('flow-builder-title', {
        edit: !!id,
        add: !id,
    });

    return (
        <div style={{ textAlign: 'center', fontSize: '14px', display: 'grid' }} className={classes}>
            <strong>{name}</strong>
            {id ? <div>{`ID: ${id}`}</div> : <div>Initially cloned from</div>}
        </div>
    );
};

export default FlowBuilderTitle;
